import React from 'react';
import { User, Wallet, Send, MessageCircle } from 'lucide-react';

const MainMenu = ({ setCurrentScreen, exchangeRate, usdtToCnyRate }) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-slate-900 p-4">
    <div className="max-w-md mx-auto pt-20">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl shadow-2xl p-8 mb-6 border border-gray-700">
        <div className="text-center mb-8">
          {/* Лого Kit8 */}
          <div className="mb-6">
            <img 
              src="/logo.png" 
              alt="Kit8 Exchange" 
              className="w-48 h-auto mx-auto"
            />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Kit8</h1>
          <h2 className="text-xl font-semibold, text-white mb-2">Пополнение Alipay/WeChat</h2>
        </div>

        <div className="space-y-3 mb-6">
          <div className="bg-gradient-to-r from-blue-900/50 to-indigo-900/50 rounded-2xl p-4 border border-blue-800/30">
            <div className="flex justify-between items-center">
              <span className="text-gray-300">RUB/CNY:</span>
              <span className="text-xl font-bold text-blue-400">
                {exchangeRate ? `${exchangeRate} ₽/¥` : 'Загрузка...'}
              </span>
            </div>
          </div>
          <div className="bg-gradient-to-r from-purple-900/50 to-pink-900/50 rounded-2xl p-4 border border-purple-800/30">
            <div className="flex justify-between items-center">
              <span className="text-gray-300">USDT/CNY:</span>
              <span className="text-xl font-bold text-purple-400">
                {usdtToCnyRate ? `${usdtToCnyRate} USDT/¥` : 'Загрузка...'}
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => setCurrentScreen('profile')}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-2xl py-4 px-6 font-semibold shadow-lg hover:shadow-xl hover:from-purple-500 hover:to-pink-500 transition-all duration-200 flex items-center justify-center gap-3"
          >
            <User className="w-5 h-5" />
            Личный кабинет
          </button>

          <button
            onClick={() => setCurrentScreen('deposit')}
            className="w-full bg-gradient-to-r from-indigo-600 to-blue-600 text-white rounded-2xl py-4 px-6 font-semibold shadow-lg hover:shadow-xl hover:from-indigo-500 hover:to-blue-500 transition-all duration-200 flex items-center justify-center gap-3"
          >
            <Wallet className="w-5 h-5" />
            Пополнить Alipay
          </button>

          <button
            onClick={() => setCurrentScreen('wechat')}
            className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-2xl py-4 px-6 font-semibold shadow-lg hover:shadow-xl hover:from-green-500 hover:to-emerald-500 transition-all duration-200 flex items-center justify-center gap-3"
          >
            <Send className="w-5 h-5" />
            Пополнить WeChat
          </button>

          <button
            onClick={() => setCurrentScreen('support')}
            className="w-full bg-gray-700 text-gray-200 rounded-2xl py-4 px-6 font-semibold hover:bg-gray-600 transition-all duration-200 flex items-center justify-center gap-3 border border-gray-600"
          >
            <MessageCircle className="w-5 h-5" />
            Чат поддержки
          </button>
        </div>
      </div>

      <div className="text-center text-sm text-gray-400">
        <p>Безопасные переводы 24/7</p>
      </div>
    </div>
  </div>
);

export default MainMenu;

